"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
var react_1 = __importStar(require("react"));
require("@splidejs/react-splide/css");
var material_1 = require("@mui/material");
var AxiosClient_1 = require("../utils/AxiosClient");
var CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
var react_splide_1 = require("@splidejs/react-splide");
var functions_1 = require("../interfaces/functions");
var AddShoppingCartOutlined_1 = __importDefault(require("@mui/icons-material/AddShoppingCartOutlined"));
var PlaylistAddCheck_1 = __importDefault(require("@mui/icons-material/PlaylistAddCheck"));
var ProductDetails_1 = __importDefault(require("./ProductDetails"));
var AllProducts = function () {
    var _a = (0, react_1.useState)({
        status: 0,
        data: [],
    }), products = _a[0], setProducts = _a[1];
    var _b = (0, react_1.useState)(true), fetching = _b[0], setFetching = _b[1];
    var _c = (0, react_1.useState)(null), selectedProduct = _c[0], setSelectedProduct = _c[1];
    (0, react_1.useEffect)(function () {
        AxiosClient_1.AxiosClient.get("/products/")
            .then(function (response) {
            if (response.data.status == 200) {
                setProducts(response.data);
            }
        })
            .catch(function (error) {
            console.log(error);
        })
            .finally(function () { return setFetching(false); });
    }, []);
    var responsive = {
        768: {
            perPage: 2,
        },
        992: {
            perPage: 3,
            perMove: 2,
        },
        640: {
            perPage: 1,
            perMove: 1,
        },
    };
    var handleViewClick = function (product) {
        setSelectedProduct(product);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.CssBaseline, null),
        react_1.default.createElement(material_1.Box, { sx: { display: "flex", width: "100%", bgcolor: "#E5E5CB" } },
            react_1.default.createElement(material_1.Box, { component: "main", sx: { flexGrow: 1, pt: 10, pl: 2 } },
                react_1.default.createElement(material_1.Container, { maxWidth: "xl" },
                    react_1.default.createElement(material_1.Typography, { variant: "h4", sx: { mb: 3, fontWeight: "bold" } }, "All Products"),
                    fetching ? (react_1.default.createElement(CircularProgress_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_splide_1.Splide, { options: {
                                perPage: 4,
                                gap: "10px",
                                breakpoints: responsive,
                                perMove: 2,
                                width: "95vw",
                                autoplay: true,
                                type: "loop",
                            }, "aria-labelledby": "reactivity-example-heading" }, products.data.map(function (product) { return (react_1.default.createElement(react_splide_1.SplideSlide, { key: product.ProductID },
                            react_1.default.createElement(material_1.Card, { sx: { maxWidth: 345, mb: 2 } },
                                react_1.default.createElement(material_1.CardMedia, { component: "img", height: "200", image: product.pro_images[0].ImagePath, alt: product.ProductName }),
                                react_1.default.createElement(material_1.CardContent, { sx: { height: 150, overflow: "hidden" } },
                                    react_1.default.createElement(material_1.Typography, { gutterBottom: true, variant: "h5", component: "div" }, product.ProductName),
                                    react_1.default.createElement(material_1.Typography, { variant: "body2", color: "text.secondary" }, product.ProductDesc),
                                    react_1.default.createElement(material_1.Typography, { variant: "h6", component: "div" },
                                        "$",
                                        product.ProductPrice.toLocaleString())),
                                react_1.default.createElement(material_1.CardActions, null,
                                    react_1.default.createElement(material_1.Button, { sx: {
                                            mr: 1,
                                            ml: 1,
                                            mb: 1,
                                        }, size: "small", color: "primary", variant: "contained", onClick: function () { return handleViewClick(product); } }, "View"),
                                    react_1.default.createElement(material_1.Tooltip, { title: "Add to cart" },
                                        react_1.default.createElement(material_1.Button, { size: "small", color: "primary", onClick: function () {
                                                console.log("pressed add to cart");
                                                console.log(product.ProductID);
                                                (0, functions_1.AddToCart)(product.ProductID);
                                            } },
                                            react_1.default.createElement(AddShoppingCartOutlined_1.default, null))),
                                    react_1.default.createElement(material_1.Tooltip, { title: "Add to wishlist" },
                                        react_1.default.createElement(material_1.Button, { size: "small", color: "primary", onClick: function () {
                                                console.log("pressed add to wishlist");
                                                console.log(product.ProductID);
                                                (0, functions_1.AddtoWishlist)(product.ProductID);
                                            } },
                                            react_1.default.createElement(PlaylistAddCheck_1.default, null))))))); }))))))),
        selectedProduct && (react_1.default.createElement(ProductDetails_1.default, { product: selectedProduct, onClose: function () { return setSelectedProduct(null); } }))));
};
exports.default = AllProducts;
